import React from 'react';
import { Card, CardContent, Grid, IconButton, ListItemIcon, ListItemText, MenuItem, Modal, TextField, Autocomplete, Button, Stack } from '@mui/material';
import { getContacts } from 'src/services/contact.service';
import PersonIcon from '@mui/icons-material/Person';
import config from 'src/config';
import Swal from 'sweetalert2';
import { updateFile, getFileSharedUsers } from 'src/services/file.service';
import ShareIcon from '@mui/icons-material/Share';

// ----------------------------------------------------------------------



class FileShareModal extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			view_type: this.props.view_type || 'menu',
            file: this.props.file || null,
            shared_users: this.props.file?.shared_users || [],
            contacts: [],
            containers: [],
			is_modal_open: false,
			loading: false,

			file_audit_logs: [],
		}
	}

    async populateContacts(search='') {
        let contactsRes = await getContacts({ search });
        if (contactsRes.error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: contactsRes.error
            });
            return;
        }
        const contactsUsernames = contactsRes?.contacts?.map(contact => contact.user.username || '') || [];
        this.setState({ contacts: contactsUsernames });
    }

    getUniqueValuesInArray(array) {
        return [...new Set(array)];
    }
    
    async componentDidMount() {
        let file = await getFileSharedUsers(this.state.file._id);
        if (!file) {
            return;
        }
        if (file.error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: file.error,
                confirmButtonText: 'Ok',
                confirmButtonColor: config.primaryColor
            });
            return;
        }

        file = file.file || null;

        let shared_users = file?.shared_users || [];
        if (shared_users.length > 0) {
            shared_users = shared_users.map(user => user.username);
        }
        this.setState({
            file: file,
            shared_users: shared_users
        });

        await this.populateContacts();
    }

	saveFile = async () => {
    
        try {
            this.setState({
                loading: true
            });

            const payload = {
                shared_users: this.state.shared_users
            }

            let save_file_response = await updateFile(this.state.file._id, payload);
            if (save_file_response.error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: save_file_response.error,
                    confirmButtonText: 'Ok',
                    confirmButtonColor: config.primaryColor
                })
                return;
            }

            Swal.fire({
                toast: true,
                position: 'bottom-end',
                icon: 'success',
                title: 'Success',
                text: 'Saved successfully',
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
            })

            if (this.props.onClose) {
                this.props.onClose();
            }
            this.setState({
                is_modal_open: false
            });
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred.',
                confirmButtonText: 'Ok',
                confirmButtonColor: config.primaryColor
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    }

	render() {
		return (
			<>
			{(this.state.view_type == 'menu') ? (
                <MenuItem
                    onClick={() => {
                        this.setState({
                            is_modal_open: true
                        });
                    }}
                >
                    <ListItemIcon>
                        <ShareIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                        Share
                    </ListItemText>
                </MenuItem>
			) : null}
			{(this.state.view_type == 'icon') ? (
				<IconButton
					onClick={() => {
                        this.setState({
                            is_modal_open: true
                        });
                    }}
					size='small'
				>
					<ShareIcon />
				</IconButton>
			) : null}
			<Modal
				open={this.state.is_modal_open}
				onClose={() => {
					if (this.props.onClose) {
						this.props.onClose();
					}
					this.setState({
						is_modal_open: false
					});
				}}
			>
				<Grid container>
					<Grid item style={modalStyle} xs={12} md={8} lg={6}>
						<Card variant='outlined'>
							<CardContent style={{ padding: 20 }}>
                                <Stack direction="column" spacing={2}>
                                <Autocomplete
                                    freeSolo
                                    multiple
                                    id="shared-users-outlined"
                                    options={this.getUniqueValuesInArray([...this.state.contacts, ...this.state.shared_users])}
                                    value={this.state.shared_users}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            shared_users: newValue
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Shared with"
                                            placeholder="Add user emails ( dMonk registered users only )"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {params.InputProps.endAdornment}
                                                        <PersonIcon />
                                                    </React.Fragment>
                                                )
                                            }}
                                            onChange={async (event) => {
                                                this.populateContacts(event.target.value);
                                            }}
                                        />
                                    )}
                                    sx={{ width: '100%' }}
                                    size="small"
                                />
                                {(this.state.file?.containers?.map((container, index) => {
                                    if (!container?.shared_users || container.shared_users.length === 0) {
                                        return null;
                                    }
                                    return (
                                        <Autocomplete
                                            key={index}
                                            freeSolo
                                            multiple
                                            value={(container?.shared_users || []).map(user => user.username)}
                                            options={(container?.shared_users || []).map(user => user.username)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label={"Shared via container " + container.name}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {params.InputProps.endAdornment}
                                                                <PersonIcon />
                                                            </React.Fragment>
                                                        )
                                                    }}
                                                />
                                            )}
                                            disabled
                                            size="small"
                                        />
                                    )
                                }))}
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={this.saveFile}
                                    disabled={this.state.loading}
                                    size="small"
                                >
                                    {this.state.loading ? 'Saving...' : 'Save'}
                                </Button>
                                </Stack>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Modal>
			</>
		);
	}
}

const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '100%',
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 2,
	maxHeight: '90%',
	overflowY: 'auto'
};

export default function (props) {
	return <FileShareModal {...props} />;
}
